module.exports = __webpack_public_path__ + "img/bg7-6.7caea569.png";